/**
 * API base URL. Empty = same-origin; Vite proxies to http://127.0.0.1:8000
 * (use with one Cloudflare tunnel on the React dev server).
 */

export const VITE_API_PROXY_PREFIXES = [
  'auth',
  'users',
  'events',
  'system',
  'schools',
  'students',
  'bulk-import',
  'documents',
  'translations',
  'query',
  'metrics',
  'reports',
  'observations',
  'graph',
  'blueprints',
  'decisions',
  'attendance',
  'academic-scores',
  'academic-reports',
  'marks-drafts',
  'exam-cycles',
  'grading-schemes',
  'handover',
  'homework',
  'quick-questioner',
  'inlog',
  'flags',
  'health-scores',
  'ptm',
  'parent-communications',
  'report-cards',
  'notifications',
  'principal-alerts',
  'blame-shield',
  'ai-chat',
  'ai-insights',
  'meeting-mode',
  'medical-records',
  'class-assignments',
  'dashboard',
  'v1',
  'interventions',
  'student-cases',
  'intervention-reports',
  'school-playbooks',
  'timeline',
  'command-center',
  'gamification',
  'topics',
  'syllabus',
  'outcomes',
  'student-story',
  'parent-users',
  'teacher-scores',
  'logging-target',
  'storage',
  'docs',
  'openapi.json',
  'redoc',
  'usage',
];

export function getApiBase() {
  const configured = import.meta.env.VITE_SWOTIFY_API_URL;
  if (configured === '' || configured === 'same-origin' || configured === 'proxy') {
    return '';
  }
  if (configured && String(configured).trim() && configured !== 'undefined') {
    return String(configured).replace(/\/$/, '');
  }
  if (import.meta.env.DEV) {
    return '';
  }
  return 'http://localhost:8000';
}

export function apiUrl(path) {
  const base = getApiBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}

export function isSwotifyApiUrl(url) {
  if (!url) return false;
  const base = getApiBase();
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const target = new URL(url, origin);
    if (base) {
      return target.href.startsWith(base);
    }
    // Same-origin only. Firebase Installations and FCM also use /v1/..., and
    // sending those with Swotify cookies makes the browser reject the token call.
    if (typeof window !== 'undefined' && target.origin !== window.location.origin) {
      return false;
    }
    const path = target.pathname;
    return VITE_API_PROXY_PREFIXES.some(
      (prefix) => path === `/${prefix}` || path.startsWith(`/${prefix}/`)
    );
  } catch {
    return false;
  }
}
